/* eslint-disable */
// TODO: rewrite this file into ES6

function object(o) {
  function F() {}
  F.prototype = o;
  return new F();
}

var globalContainer = {};
var userContainer = object(globalContainer);
var pageContainer = object(userContainer);

var changeListeners = {
  0: {},
  1: {},
  2: {}
};

/**
 * Get setting from desired place
 * @param {string} key
 * @param {number} [type]
 */
var Settings = {

  /**
   *
   * @returns {Settings}
   */
  init: function(){
    // Read in application in-line page data
    var settings = document.getElementById("app.settings");
    if(settings){
      try {
        this.apply(JSON.parse(settings.innerHTML), Settings.Type.GLOBAL);
      }
      catch(e){
          console.error("App.Settings", e);
      }
    }

    var data = document.getElementById("app.data");
    if (data) {
      try {
        this.apply(JSON.parse(data.innerHTML), Settings.Type.PAGE);
      } catch(e) {
        console.error("App.Data", e);
      }
    }

    if (window.GROUPCALL_RESULT) {
      this.apply(window.GROUPCALL_RESULT, Settings.Type.USER);
    } else if (this.get('groupcallIsLoading', Settings.Type.USER) === undefined){
      this.apply({groupcallIsLoading: true}, Settings.Type.USER);
    }
    return this;
  },

  get: function (key, type) {
    type = type === undefined ? this.Type.PAGE : type;
    var result = this[type][key]; 
    if (typeof result === 'object' || typeof result === 'array') {
      result = JSON.parse(JSON.stringify(result))
    }   
    return result;
  },

  /**
   * Set setting in desired place
   * @param {string} key
   * @param {*} value
   * @param {number} [type]
   */
  set: function (key, value, type, bulk) {
    type = type === undefined ? this.Type.PAGE : type;
    this[type][key] = value;
    if (!bulk) {
      this.notifyChanges(key, type);
    }
  },

  load: function (url) {
    // todo Return Promise for a specific URL
  },

  /**
   * Sets various keys (useful for extensibility functions as backend could update keys and we will have them)
   * @param keys
   * @param type
   */
  apply: function (keys, type) {
    for (var prop in keys) {
      if (keys.hasOwnProperty(prop)) {
        this.set(prop, keys[prop], type, true);
      }
    }
    for (var prop in keys) {
      this.notifyChanges(prop, type);
    }
  },

  notifyChanges: function(key, type) {
    for (var i = 0; i < (changeListeners[type][key] ? changeListeners[type][key].length : 0); i++) {
      var callback = changeListeners[type][key][i];
      if (typeof callback === 'function') {
        callback(this.get(key, type));
      }
    }
  },

  /**
   * add watcher for changes, callback will be fired when something change
   * @param  {string}   key      selector
   * @param  {int}      type     Settings.Type
   * @param  {Function} callback
   */
  watchChanges: function(key, type, callback) {
    changeListeners[type][key] = changeListeners[type][key] || [];
    changeListeners[type][key].push(callback);
  },

  0: globalContainer,
  1: userContainer,
  2: pageContainer
};

Settings.Type = {
  GLOBAL: 0,
  USER: 1,
  PAGE: 2
};

module.exports = Settings;
